// Types
import { DeliveryMethodType, DeliveryProps } from 'types/Delivery.types';

// Config
import appConstants from '@constants/appConstants';
import deliveryConstants, { apoDeliveryTypes, fulfilmentTypes } from '@constants/deliveryConstants';

// Choice type
export const isDeliveryChoice = (choiceId: string | undefined) => choiceId === deliveryConstants.DELIVERY;
export const isClickAndCollectChoice = (choiceId: string | undefined) =>
  choiceId === deliveryConstants.CLICK_AND_COLLECT;

// Delivery
export const isOneMan = (deliveryType?: string) => [
  deliveryConstants.ONE_MAN,
  apoDeliveryTypes.ONE_PERSON,
  apoDeliveryTypes.ONE_PERSON_PRE_ORDER,
].includes(deliveryType ?? '');
export const isGreenVanFleet = (deliveryType?: string) => [
  deliveryConstants.GREEN_VAN_FLEET,
  apoDeliveryTypes.TWO_PERSON,
].includes(deliveryType ?? '');
export const isSupplierDirect = (deliveryType?: string) => [
  deliveryConstants.SUPPLIER_DIRECT,
  apoDeliveryTypes.STANDARD_SUPPLIER_DIRECT,
  apoDeliveryTypes.SOR_SUPPLIER_DIRECT,
].includes(deliveryType ?? '');
export const isGreenVanFleetExCatchment = (deliveryType?: string, fulfilment?: DeliveryMethodType) =>
  isGreenVanFleet(deliveryType) && (
    (fulfilment?.bookingType === deliveryConstants.NIGHTFREIGHT) ||
    (fulfilment?.fulfilmentType === fulfilmentTypes.TWO_PERSON_OUT_OF_AREA)
  );
export const isGreenVanFleetUnavailable = (deliveryType?: string, fulfilment?: DeliveryMethodType) =>
  isGreenVanFleet(deliveryType) && !fulfilment?.deliveryInfo?.date;
export const isMadeToMeasureDelivery = (deliveryType?: string) => deliveryType === deliveryConstants.MADE_TO_MEASURE;
export const isOneManDeliveryOfType = (delivery: DeliveryProps, type: string) => {
  return isOneManPremiumDelivery(delivery) && delivery.fulfilment?.fulfilmentType === type;
};
export const isOneManPremiumDelivery = (delivery: DeliveryProps) =>
  isOneMan(delivery.type) && !!delivery.fulfilment?.deliveryInfo?.date;
export const isOneManMorningDelivery = (delivery: DeliveryProps) =>
  isOneManDeliveryOfType(delivery, fulfilmentTypes.ONE_PERSON_NAMED_DAY_MORNING);
export const isOneManEveningDelivery = (delivery: DeliveryProps) =>
  isOneManDeliveryOfType(delivery, fulfilmentTypes.ONE_PERSON_NAMED_DAY_EVENING);
export const isOneManDayDelivery = (delivery: DeliveryProps) =>
  isOneManDeliveryOfType(delivery, fulfilmentTypes.ONE_PERSON_NAMED_DAY);

// Collection
export const isClickCollect = (delivery?: DeliveryProps) => !!delivery?.fulfilment?.collectionInfo;

// Delivery instructions
export const getDeliveryInstructionDropdownOptions = () => {
  const options = appConstants.DELIVERY_INSTRUCTIONS.map((item) => ({
    ...item,
    value: item.label,
    label: item.label,
    prefix: `${item.label}:`,
  }));

  return [{ label: 'Select an option:', value: '' }, ...options];
};
